import { Link } from "react-router"
import LinkButton from "./LinkButton"

interface IconLinkButtonProps {
    src: string
    label: string
    className?: string
    to: string,
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void 
    floating?: "left" | "right"
}

function IconLinkButton({ src, label, to, onClick, className = "", floating = "right" }: IconLinkButtonProps) {
    return <LinkButton
        to={to}
        onClick={onClick}
        className={
            'p-1 pr-2 ' +
            (floating == "left" ? 'flex flex-row-reverse items-center ' : '') +
            className
        }
    >
        <img src={src} alt="icon" draggable={false} className="w-8 inline" />
        <span className="inline align-middle">{label}</span>
    </LinkButton>
}

export default IconLinkButton